const MAX_STRING_LENGTH = 120

function tryParseDeep(value: unknown): unknown {
  if (typeof value === 'string') {
    try {
      return tryParseDeep(JSON.parse(value))
    } catch {
      return value.length > MAX_STRING_LENGTH ? value.slice(0, MAX_STRING_LENGTH) + '…' : value
    }
  }
  if (Array.isArray(value)) {
    return value.map(tryParseDeep)
  }
  if (value !== null && typeof value === 'object') {
    const result: Record<string, unknown> = {}
    for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
      result[k] = tryParseDeep(v)
    }
    return result
  }
  return value
}

export function tryParseStringFields(obj: Record<string, unknown>): Record<string, unknown> {
  return tryParseDeep(obj) as Record<string, unknown>
}

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

export function highlightJson(json: string): string {
  return json
    .replace(/"([^"]+)":\s*/g, (_, key: string) => `<span class="text-blue-300">"${escapeHtml(key)}"</span>: `)
    .replace(/:\s*"([^"]*?)"/g, (_, value: string) => `: <span class="text-green-300">"${escapeHtml(value)}"</span>`)
    .replace(/:\s*(\d+\.?\d*)/g, ': <span class="text-yellow-300">$1</span>')
    .replace(/:\s*(true|false)/g, ': <span class="text-yellow-300">$1</span>')
    .replace(/:\s*(null)/g, ': <span class="text-gray-500">$1</span>')
}
